import { FC, useContext, useMemo } from 'react'
import PageContainer from 'shared/components/PageContainer'
import { ArrowLeft } from 'lucide-react'
import LocalizationContext from 'shared/contexts/LocalizationContext'

type Props = {
  name: string
  mediaType: string
  photo: Blob
  onVerify: () => void
  onRegister: () => void
  locale: string
}

const PostRegistration: FC<Props> = ({
  name,
  photo,
  onRegister,
  onVerify,
  locale
}) => {
  // Create a URL for the photo Blob
  const photoURL = useMemo(() => URL.createObjectURL(photo), [photo])
  const { getString } = useContext(LocalizationContext)

  return (
    <PageContainer>
      <div className='flex flex-col items-center justify-start min-h-screen bg-gray-50 pt-16 sm:pt-24 px-4'>
        <div className='w-full max-w-sm bg-white rounded-xl shadow-sm p-6 sm:p-8'>
          {/* Back button - top left */}
          <button
            onClick={onRegister}
            className='flex items-center gap-1 text-gray-500 hover:text-gray-700 text-sm mb-6'
          >
            <ArrowLeft size={16} />
            <span>{getString('start_over', locale)}</span>
          </button>

          {/* Photo section */}
          <div className='flex flex-col items-center mb-8'>
            <img
              src={photoURL}
              alt='Registered user'
              className='w-32 h-32 rounded-full object-cover border-2 border-gray-200 bg-gray-100'
            />
            {name && (
              <h2 className='mt-4 text-xl font-semibold text-gray-800'>
                {name}
              </h2>
            )}
          </div>

          {/* Start Demo Button */}
          <button
            className='
              w-full py-3 rounded-full
              bg-green-500 text-white font-medium
              flex items-center justify-center
              gap-2
              shadow
              transition
              hover:bg-green-600
              active:bg-green-700
              focus:outline-none
              cursor-pointer
              text-base
            '
            onClick={onVerify}
          >
            <span>{getString('start_demo', locale)}</span>
          </button>
        </div>
      </div>
    </PageContainer>
  )
}

export default PostRegistration
